export class OTTCCPACardsSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(this, new VendorCardsSettings(overrides), new CategoryCardsSettings(overrides), new DetailsCardSettings(overrides));
  }
}
class VendorCardsSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      alphabetizeVendors: false,
      vendorHeight: {
        type: 'px',
        value: 240
      },
      vendorWidth: {
        type: '%',
        value: 100
      },
      vendorPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      vendorMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      vendorBackground: '#e3e3e3',
      vendorCardsHeight: {
        type: 'px',
        value: 150
      },
      vendorCardsWidth: {
        type: 'px',
        value: 150
      },
      vendorCardsMargin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      vendorCardsBackground: '#ffffff',
      vendorCardsPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      vendorCardsFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorCardsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      vendorSwitchOnColor: '#47d747',
      vendorSwitchOffColor: '#cccccc',
      vendorCountFont: {
        fontSize: 12,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorCountText: 'vendors',
      noVendorsFoundFont: {
        fontSize: 21,
        fontWeight: '400',
        color: '#0000006b',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      noVendorsFoundText: 'No Vendors Found!'
    };
    Object.assign(this, defaults, overrides);
  }
}
class CategoryCardsSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      categoryHeight: {
        type: 'px',
        value: 240
      },
      categoryWidth: {
        type: '%',
        value: 100
      },
      categoryPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      categoryMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      categoryCardsBackground: 'white',
      categoryCardsHeight: {
        type: 'px',
        value: 150
      },
      categoryCardsWidth: {
        type: 'px',
        value: 150
      },
      categoryCardsMargin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      categoryCardsPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      categoryCardsFont: {
        fontSize: 16,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryCardsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      categorySwitchOnColor: '#47d747',
      categorySwitchOffColor: '#cccccc'
    };
    Object.assign(this, defaults, overrides);
  }
}
;
class DetailsCardSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      vendorDetailsBackground: '#e3e3e3',
      vendorDetailsHeight: {
        type: '%',
        value: 100
      },
      vendorDetailsWidth: {
        type: '%',
        value: 100
      },
      vendorDetailsPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      vendorDetailsMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      vendorDetailsReturnFont: {
        fontSize: 16,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsTitleFont: {
        fontSize: 16,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsDescriptionFont: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsDescriptionPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 5,
        paddingBottom: 5
      },
      vendorDetailsCardBackground: 'white',
      vendorDetailsCardHeight: {
        type: '%',
        value: 100
      },
      vendorDetailsCardWidth: {
        type: '%',
        value: 90
      },
      vendorDetailsCardPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      vendorDetailsCardMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      vendorDetailsCardTitlePadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      vendorDetailsCardFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsCardListPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      vendorDetailsCardTitleText: 'Purposes',
      vendorDetailsCardTitleFont: {
        fontSize: 14,
        fontWeight: '400',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsCardBorder: {
        borderWidth: 1,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderStyle: 'solid'
      },
      vendorDetailsReturnText: 'RETURN',
      vendorDetailsReturnArrowIcon: '',
      vendorReturnIconWidth: {
        type: 'px',
        value: 10
      },
      vendorReturnIconPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      vendorDetailsCategoryCountFont: {
        fontSize: 16,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsSwitchOnColor: '#47d747',
      vendorDetailsSwitchOffColor: '#cccccc',
      vendorDetailsLanguages: {},
      vendorDetailsVendorQRText: 'To scan use your camera app or a QR code reader on your device',
      vendorDetailsVendorQRFont: {
        fontSize: 12,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      vendorDetailsVendorQRPadding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      categoryDetailsBackground: 'white',
      categoryDetailsHeight: {
        type: '%',
        value: 100
      },
      categoryDetailsWidth: {
        type: '%',
        value: 100
      },
      categoryDetailsPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      categoryDetailsMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      categoryDetailsBorder: {
        borderWidth: 2,
        borderColor: '#7e7b7b',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      categoryDetailsReturnText: 'RETURN',
      categoryDetailsReturnFont: {
        fontSize: 16,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsTitleFont: {
        fontSize: 16,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsDescriptionFont: {
        fontSize: 14,
        fontWeight: '500',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsDescriptionPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 5,
        paddingBottom: 5
      },
      categoryDetailsVendorCountText: 'Vendors',
      categoryDetailsVendorCountFont: {
        fontSize: 14,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsSwitchOnColor: '#47d747',
      categoryDetailsSwitchOffColor: '#cccccc',
      categoryDetailsVendorContainerColor: '#ffffff2e',
      categoryDetailsVendorUrl: false,
      categoryDetailsVendorFont: {
        fontSize: 14,
        fontWeight: '600',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryDetailsVendorUrlFont: {
        fontSize: 11,
        fontWeight: '300',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      detailsPreviewIndex: 0,
      languages: {},
      selectedLanguage: 'EN',
      categoryDetailsVendorBorder: {
        borderWidth: 1,
        borderColor: '#7e7b7b',
        borderStyle: 'solid'
      },
      categoryDetailsVendorPadding: {
        paddingLeft: 5,
        paddingRight: 5,
        paddingTop: 5,
        paddingBottom: 5
      },
      iconUrl: '',
      iconPadding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      iconMargin: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0
      },
      iconWidth: {
        type: 'px',
        value: 10
      },
      categoryFooterPadding: {
        paddingLeft: 5,
        paddingRight: 5,
        paddingTop: 5,
        paddingBottom: 5
      },
      categoryFooterFont: {
        fontSize: 11,
        fontWeight: '300',
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      categoryFooterAlign: 'center',
      categoryFooterInput: 'Press DOWN arrow to navigate to vendors'
    };
    Object.assign(this, defaults, overrides);
  }
}
export const OTTCCPACardsTypes = {
  'vendors content': {
    alphabetizeVendors: {
      title: 'Sort Vendors Alphabetically?',
      type: 'Switch'
    }
  },
  'vendors container orientation': {
    vendorWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendors container style': {
    vendorBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    }
    // vendorBorder: { title: 'Border', type: 'Border' },
  },

  'vendors cards orientation': {
    vendorCardsHeight: {
      title: 'Height',
      type: 'Size'
    },
    vendorCardsWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorCardsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorCardsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendors cards style': {
    vendorCardsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    vendorCardsBorder: {
      title: 'Border',
      type: 'Border'
    },
    vendorCardsFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  'vendors count style': {
    vendorCountFont: {
      title: 'Vendor Count Font',
      type: 'Font'
    }
  },
  'vendors count text': {
    vendorCountText: {
      title: 'Vendor Count Text',
      type: 'InputLanguage'
    }
  },
  'no vendors found style': {
    noVendorsFoundFont: {
      title: 'No Vendors Found Font',
      type: 'Font'
    }
  },
  'no vendors found text': {
    noVendorsFoundText: {
      title: 'No Vendors Found Text',
      type: 'InputLanguage'
    }
  },
  'vendors switch style': {
    vendorSwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    vendorSwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'categories orientations': {
    categoryWidth: {
      title: 'Width',
      type: 'Size'
    },
    categoryHeight: {
      title: 'Height',
      type: 'Size'
    },
    categoryPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'categories style': {
    categoryBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    }
  },
  'categories cards orientation': {
    categoryCardsHeight: {
      title: 'Height',
      type: 'Size'
    },
    categoryCardsWidth: {
      title: 'Width',
      type: 'Size'
    },
    categoryCardsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryCardsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'categories cards style': {
    categoryCardsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    categoryCardsBorder: {
      title: 'Border',
      type: 'Border'
    },
    categoryCardsFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  'categories switch style': {
    categorySwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    categorySwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'category details orientation': {
    categoryDetailsWidth: {
      title: 'Width',
      type: 'Size'
    },
    categoryDetailsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryDetailsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'category details style': {
    categoryDetailsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    categoryDetailsBorder: {
      title: 'Border',
      type: 'Border'
    }
  },
  'category details title font': {
    categoryDetailsTitleFont: {
      title: 'Category Title Font',
      type: 'Font'
    }
  },
  'category details description': {
    categoryDetailsDescriptionFont: {
      title: 'Category Description Font',
      type: 'Font'
    },
    categoryDetailsDescriptionPadding: {
      title: 'Padding',
      type: 'Padding'
    }
  },
  'category details switch style': {
    categoryDetailsSwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    categoryDetailsSwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'category details vendor count': {
    categoryDetailsVendorCountText: {
      title: 'Text',
      type: 'InputLanguage'
    },
    categoryDetailsVendorCountFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  'category details return button': {
    categoryDetailsReturnText: {
      title: 'Text',
      type: 'InputLanguage'
    },
    categoryDetailsReturnFont: {
      title: 'Font',
      type: 'Font'
    }
  },
  'category details vendor description styles': {
    categoryDetailsVendorContainerColor: {
      title: 'Container Color',
      type: 'ColorPicker'
    },
    categoryDetailsVendorPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    categoryDetailsVendorFont: {
      title: 'Vendor Name Font',
      type: 'Font'
    },
    categoryDetailsVendorUrlFont: {
      title: 'Vendor URL Font',
      type: 'Font'
    },
    categoryDetailsVendorBorder: {
      title: 'Border',
      type: 'Border'
    },
    iconUrl: {
      title: 'Icon URL',
      type: 'Input'
    },
    iconPadding: {
      title: 'Icon Padding',
      type: 'Padding'
    },
    iconMargin: {
      title: 'Icon Margin',
      type: 'Margin'
    },
    iconWidth: {
      title: 'Icon Width',
      type: 'Size'
    }
  },
  'category footer styles': {
    categoryFooterInput: {
      title: 'Input',
      type: 'Input'
    },
    categoryFooterFont: {
      title: 'Vendor Name Font',
      type: 'Font'
    },
    categoryFooterAlign: {
      title: 'Text Align',
      type: 'Align'
    },
    categoryFooterPadding: {
      title: 'Inner Spacing',
      type: 'Padding'
    }
  },
  'vendor details orientation': {
    vendorDetailsWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorDetailsPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorDetailsMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendor details style': {
    vendorDetailsBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    }
  },
  'vendor details title style': {
    vendorDetailsTitleFont: {
      title: 'Vendor Title Font',
      type: 'Font'
    }
  },
  'vendor details description style': {
    vendorDetailsDescriptionFont: {
      title: 'Category Description Font',
      type: 'Font'
    },
    vendorDetailsDescriptionPadding: {
      title: 'Padding',
      type: 'Padding'
    }
  },
  'vendor details card orientation': {
    vendorDetailsCardHeight: {
      title: 'Height',
      type: 'Size'
    },
    vendorDetailsCardWidth: {
      title: 'Width',
      type: 'Size'
    },
    vendorDetailsCardPadding: {
      title: 'Padding',
      type: 'Padding'
    },
    vendorDetailsCardMargin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  'vendor details card style': {
    vendorDetailsCardBackground: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    vendorDetailsCardBorder: {
      title: 'Border',
      type: 'Border'
    },
    vendorDetailsCardTitleText: {
      title: 'Title Text',
      type: 'InputLanguage'
    },
    vendorDetailsCardTitleFont: {
      title: 'Title Font',
      type: 'Font'
    },
    vendorDetailsCardTitlePadding: {
      title: 'Title Padding',
      type: 'Padding'
    },
    vendorDetailsCardFont: {
      title: 'List Item Font',
      type: 'Font'
    },
    vendorDetailsCardListPadding: {
      title: 'List Item Padding',
      type: 'Padding'
    }
  },
  'vendor details switch style': {
    vendorDetailsSwitchOnColor: {
      title: 'ON Color',
      type: 'ColorPicker'
    },
    vendorDetailsSwitchOffColor: {
      title: 'OFF Color',
      type: 'ColorPicker'
    }
  },
  'vendor QR card': {
    vendorDetailsVendorQRText: {
      title: 'Text',
      type: 'InputLanguage'
    },
    vendorDetailsVendorQRFont: {
      title: 'Font',
      type: 'Font'
    },
    vendorDetailsVendorQRPadding: {
      title: 'Padding',
      type: 'Padding'
    }
  },
  'vendor and category details return button': {
    vendorDetailsReturnArrowIcon: {
      title: 'Icon URL',
      type: 'Input'
    },
    vendorReturnIconWidth: {
      title: 'Icon Width',
      type: 'Size'
    },
    vendorReturnIconPadding: {
      title: 'Icon Padding',
      type: 'Padding'
    },
    vendorDetailsReturnText: {
      title: 'Text',
      type: 'InputLanguage'
    },
    vendorDetailsReturnFont: {
      title: 'Font',
      type: 'Font'
    }
  }
};